import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProcurementCategoryBasicDetailsModel, ProcurementCategoryDetailsModel, ProcurementCategoryModel, ProcurementCategorySaveModel, SearchModel, SearchResultModel } from 'src/common';
import { environment } from 'src/environments/environment';

const localApiUrl = `${environment.apiUrl}/ProcurementCategories`;

@Injectable()
export class ProcurementCategoriesService {

    constructor(private http: HttpClient) { }

    searchProcurementCategories(search: SearchModel): Promise<SearchResultModel<ProcurementCategoryModel>> {
        return this.http.post<SearchResultModel<ProcurementCategoryModel>>(`${localApiUrl}/SearchProcurementCategories`, search).toPromise();
    }

    search(search: SearchModel): Promise<SearchResultModel<ProcurementCategoryModel>> {
        return this.http.post<SearchResultModel<ProcurementCategoryModel>>(`${localApiUrl}/Search`, search).toPromise();
    }

    getAll(): Promise<ProcurementCategoryModel[]> {
        return this.http.get<ProcurementCategoryModel[]>(`${localApiUrl}/All`).toPromise();
    }

    getById(id: number): Promise<ProcurementCategoryDetailsModel> {
        return this.http.get<ProcurementCategoryDetailsModel>(`${localApiUrl}/Details/${id}`).toPromise();
    }

    getBasicById(id: number): Promise<ProcurementCategoryBasicDetailsModel> {
        return this.http.get<ProcurementCategoryBasicDetailsModel>(`${localApiUrl}/BasicDetails/${id}`).toPromise();
    }

    delete(id: number): Promise<void> {
        return this.http.delete<void>(`${localApiUrl}/Delete/${id}`).toPromise();
    }

    save(model: ProcurementCategorySaveModel): Promise<void> {
        return this.http.post<void>(`${localApiUrl}/Save`, model).toPromise();
    }
}
